{
  "name": "openpipe-dev",
  "version": "0.49.0",
  "type": "module",
  "description": "OpenPipe TypeScript SDK: Fine-Tuning, Inference, and Metrics for Production Apps",
  "scripts": {
    "build": "./build.sh",
    "build-update": "./build.sh && ./update-app.sh",
    "test": "vitest --no-file-parallelism",
    "test:fast": "vitest --no-file-parallelism -t '^(?!.*\\[slow\\]).*$'"
  },
  "main": "./src/index.ts",
  "publishConfig": {
    "name": "openpipe",
    "access": "public",
    "main": "./index.cjs",
    "module": "./index.js",
    "types": "./index.d.ts",
    "exports": {
      ".": {
        "import": "./index.js",
        "require": "./index.cjs"
      },
      "./client": {
        "import": "./client.js",
        "require": "./client.cjs"
      },
      "./openai": {
        "import": "./openai.js",
        "require": "./openai.cjs"
      },
      "./openai/mergeChunks": {
        "import": "./openai/mergeChunks.js",
        "require": "./openai/mergeChunks.cjs"
      }
    }
  },
  "keywords": [
    "OpenPipe",
    "LLM",
    "Fine-tuning",
    "AI"
  ],
  "author": "",
  "license": "Apache-2.0",
  "dependencies": {
    "@anthropic-ai/sdk": "^0.39.0",
    "encoding": "0.1.13",
    "form-data": "4.0.1",
    "node-fetch": "2.7.0",
    "openai": "^4.94.0"
  },
  "devDependencies": {
    "@rollup/plugin-json": "^6.1.0",
    "@rollup/plugin-node-resolve": "^15.3.0",
    "@types/node": "^22.7.8",
    "@types/node-fetch": "^2.6.11",
    "dotenv": "^16.4.5",
    "rollup": "^4.24.0",
    "rollup-plugin-typescript2": "^0.36.0",
    "tslib": "^2.8.0",
    "tsup": "^8.3.0",
    "tsx": "^4.19.1",
    "typescript": "^5.6.3",
    "vitest": "^3.0.8",
    "yalc": "1.0.0-pre.53",
    "zod": "^3.23.8"
  }
}
